// auth.service.js
import api, { uploadApi } from './api';

export const authService = {
  async login(email, password) {
    try {
      console.log(api.baseURL);
      const response = await api.post('/auth/login', { email, password });
      if (response.data.data && response.data.data.token) {
        localStorage.setItem('token', response.data.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        
        return response.data;
      }
      throw new Error('Login failed');
    } catch (error) {
      throw error;
    }
  },

  async register(userData) {
    try {
      // Use uploadApi for FormData requests (no default Content-Type header)
      const response = await uploadApi.post('/auth/register', userData);
      
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  async forgotPassword(email) {
    return await api.post('/auth/forgot-password', { email });
  },

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
};